'use client';

import Header from '@/components/common/Header';
import ImprintInteractive from './components/ImprintInteractive';
import FooterWrapper from '@/components/common/FooterWrapper';

export default function ImprintPage() {
  return (
    <>
      <Header />
      <main>
        <ImprintInteractive />
      </main>
      <FooterWrapper />
    </>
  );
}